import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { BillTypeListMaintenanceDto } from './BillTypeListMaintenanceDto';
import { BillTypeItemMaintenanceDto } from './BillTypeItemMaintenanceDto';
import { BaseMaintenanceController } from '../_base/BaseMaintenanceController';

@Injectable()
export class BillTypeMaintenanceController extends BaseMaintenanceController<BillTypeListMaintenanceDto, BillTypeItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "activity/billtype");
    }


    public getResourceRoot(): string {
        return "BILLTYPE";
    }

    public buildUrl(uri: string): string {
        return "system/dataandparameters/billtype" + uri;
    }
}